<section class="questionnaire" [style.paddingBottom.px]="footerSpacerPx">
  <section class="questionnaire-header">
    <mat-progress-bar
      class="q-progress"
      mode="determinate"
      [value]="getProgressBarValue()"
    />
    <ng-container *ngIf="questionnaire">
      <ng-container
        *ngIf="!atualPage() || !getQuestionnairePage(atualPage()!.page)"
      >
        <h2 class="questionnaire-title">Questionnaire Page</h2>
      </ng-container>
      <ng-container
        *ngIf="atualPage() && getQuestionnairePage(atualPage()!.page)"
      >
        <h2 class="questionnaire-title">
          {{ getQuestionnairePage(atualPage()!.page)!.name }}
        </h2>
      </ng-container>
      <!-- <p class="questionnaire-description">
        {{ questionnaire.name }}
      </p> -->
    </ng-container>
    <ng-container *ngIf="!questionnaire">
      <div class="loading-header">
        <ngx-skeleton-loader count="2" appearance="line"></ngx-skeleton-loader>
      </div>
    </ng-container>
  </section>
  <section *ngIf="!(loading$ | async)?.loading" class="questionnaire-page">
    <ng-container *ngIf="questionnaire && navstack.length > 0">
      <ng-container *ngFor="let page of navstack">
        <ng-container *ngIf="page.isActive">
          <questionnaire-answer-page
            [page]="getQuestionnairePage(page.page)!"
            [questionnaire]="questionnaire"
            [caseAllowsSimpleQuestionnaire]="caseAllowsSimpleQuestionnaire"
            [questionnaireAnswer$]="getAnswersObservable()"
            [ineligibilityInfo]="getIneligibilityInfo()"
            [user]="user"
            (onChangeQuestionnaireAnswer)="onChangeQuestionnaireAnswer($event)"
            (onChangePageValid)="onChangePageValid($event)"
            (onLoadingPage)="onPageLoading($event)"
          />
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="!(questionnaire && navstack.length > 0)">
      <div class="loading-page">
        <mat-spinner diameter="40" />
        <p>{{ "Loading..." | translate }}</p>
      </div>
    </ng-container>
  </section>
  <ng-container *ngIf="(loading$ | async)?.loading">
    <div class="loading-page">
      <mat-spinner diameter="40" />
      <p>{{ "Loading..." | translate }}</p>
    </div>
  </ng-container>
  <section
    #footerBar
    class="questionnaire-footer"
    [class.questionnaire-footer--fixed]="fixedFooter"
    *ngIf="!(loading$ | async)?.loading"
  >
    <div class="errors-content" *ngIf="hasVisibleErrors()">
      <p *ngFor="let item of getErrorsList().page">
        <mat-icon>close</mat-icon> {{ item }}
      </p>
      <p *ngFor="let item of getErrorsList().global">
        <mat-icon>close</mat-icon> {{ item }}
      </p>
    </div>
    <div class="change-page-btns-content">
      <ng-container *ngIf="questionnaire">
        <button
          *ngIf="isPreviousAllowed"
          mat-stroked-button
          class="btn-outline-content"
          (click)="goPrev()"
        >
          {{ "GoBack" | translate }}
        </button>
        <button
          mat-raised-button
          class="btn-lg btn-dark"
          (click)="goNext()"
          (mouseenter)="onNextButtonHover()"
          [disabled]="!isNextAllowed || loadingPage"
        >
          {{ (getProgressBarValue() === 100 ? "Proceed" : "Next") | translate }}
        </button>
      </ng-container>
    </div>
  </section>
</section>
